import { useSnapshot } from 'valtio'
import { QuadrantLink } from '@/components/QuadrantLink/QuadrantLink'
import { RingList } from '@/components/RingList/RingList'
import { groupItemsByQuadrant } from '@/lib/data'
import { Link } from '@/lib/navigation'
import { state } from '@/lib/state'
import type { Item } from '../../../../types'
import styles from './QuadrantList.module.css'

interface QuadrantListProps {
  items: readonly Item[]
}

export function QuadrantList({ items }: QuadrantListProps) {
  const { radarConfig } = useSnapshot(state)
  const quadrants = radarConfig?.quadrants || []
  const groupedItems = groupItemsByQuadrant(items)
  const quadrantData = Object.fromEntries(
    Object.entries(groupedItems).map(([quadrantId, items]) => {
      const quadrant = quadrants.find(q => q.id === quadrantId)
      return [quadrantId, { items, quadrant }]
    })
  )

  return (
    <ul className={styles.quadrants} data-testid="quadrant-list">
      {Object.entries(quadrantData).map(([quadrantId, { items, quadrant }]) => {
        if (!quadrant) return null
        return (
          <li
            key={quadrantId}
            className={styles.quadrant}
            data-testid={`quadrant-list-item-${quadrant.id}`}
          >
            <div className={styles.header} data-testid="quadrant-list-header">
              <h3 className={styles.title}>
                <Link href={`${quadrant.id}`}>{quadrant.title}</Link>
              </h3>
              <QuadrantLink quadrant={quadrant} />
            </div>
            <RingList items={Array.isArray(items) ? items : []} size="small" />
          </li>
        )
      })}
    </ul>
  )
}
